import type { ReactNode } from 'react'

import estilos from './Aviso.module.css'

type TipoAviso = 'info' | 'exito' | 'alerta' | 'error'

type PropsAviso = {
  tipo?: TipoAviso
  titulo?: string
  children: ReactNode
}

/**
 * Mensaje al usuario. Los errores se anuncian a los lectores de pantalla
 * (role="alert") porque interrumpen lo que la persona estaba haciendo; los
 * informativos no, para no interrumpir por algo que solo acompaña.
 */
export function Aviso({ tipo = 'info', titulo, children }: PropsAviso) {
  return (
    <div
      className={`${estilos.aviso} ${estilos[tipo]}`}
      role={tipo === 'error' ? 'alert' : 'status'}
    >
      <span className={estilos.marca} aria-hidden="true" />

      <div className={estilos.contenido}>
        {titulo && (
          <>
            <b>{titulo}</b>
            <br />
          </>
        )}
        {children}
      </div>
    </div>
  )
}
